import { render, staticRenderFns } from "./AddDealerDialog.vue?vue&type=template&id=fffcb356&scoped=true"
import script from "./AddDealerDialog.vue?vue&type=script&lang=js"
export * from "./AddDealerDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDealerDialog.vue?vue&type=style&index=0&id=fffcb356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffcb356",
  null
  
)

export default component.exports